<mat-icon *ngIf="icon" [svgIcon]="icon" class="square-icon feature-icon"></mat-icon>

<h3 class="feature-title">{{ title }}</h3>

<div class="feature-description"><ng-content></ng-content></div>
